import CompositeNodeBase from './CompositeNodeBase';

/**
 * Base building block for leaf nodes of composite hierarchies that conform to
 * the {@link CompositeNodeBase} interface.
 */
abstract class CompositeLeafNodeBase<
  T extends CompositeNodeBase<any>,
> implements CompositeNodeBase<T> {
  private parent: T | null = null;

  public addChild(child: T): void {
    this.addChildUnchecked(child);
  }

  public addChildUnchecked(_child: T): void {
    throw new Error('Cannot add a child to a leaf node');
  }

  public *getChildren(): IterableIterator<T> {
    // not implemented
  }

  public getChildrenCopy(): T[] {
    return [];
  }

  public hasChildren(): boolean {
    return false;
  }

  public getChildrenCount(): number {
    return 0;
  }

  public getParent(): T | null {
    return this.parent;
  }

  public setParent(parent: T | null): void {
    this.parent = parent;
  }
}

export default CompositeLeafNodeBase;
